export const MODELS_WITHOUT_TIME_FRAME = ["mix"];
